import { v4 as uuidv4 } from 'uuid';

if (!('randomUUID' in crypto)) {
  (crypto as Crypto).randomUUID = uuidv4 as () => `${string}-${string}-${string}-${string}-${string}`;
}
